export default "__VITE_ASSET__af1113e8__"